// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';

import PriceOptionsForm from '../../ui/components/Forms/PriceOption';
import { getFees } from '../../selectors/accessFees';
import {
    fetchAccessFees,
    selectFee,
    setForm,
    freemium,
    closeModal,
} from '../../actions';
import { isFreemium } from '../../utils/helpers';
import { PAYMENTS_FORM, MY_ACCOUNT_FORM } from '../../constants/forms';

type Props = {
    fees: Array<any>,
    modal: {
        assetID: number,
    },
    clientID: string,
    language: string,
    branding: Object,
    selectFee: Function,
    setForm: Function,
    freemium: Function,
    fetchAccessFees: Function,
};

export class PriceOptions extends Component<Props> {
    componentDidMount() {
        this.props.fetchAccessFees(this.props.modal.assetID);
    }

    componentDidUpdate(nextProps: Props) {
        if (this.props.fees && this.props.fees.length === 1) {
            const access_fee = this.props.fees[0];
            if (isFreemium(access_fee)) {
                this.props.freemium(
                    access_fee.id,
                    this.props.assetID,
                    this.props.clientID
                );
                this.props.closeModal();
            } else {
                this.props.selectFee(access_fee.id);
                this.props.setForm(PAYMENTS_FORM);
            }
        }
    }

    handleSubmit = (feeID: number) => {
        const fee = this.props.fees.find(fee => fee.id === feeID);
        this.props.selectFee(feeID);
        this.props.setForm(PAYMENTS_FORM);
    };

    handleBack = () => {
        this.props.setForm(MY_ACCOUNT_FORM);
    };

    render() {
        return (
            <PriceOptionsForm
                fees={this.props.fees}
                onSubmit={this.handleSubmit}
                handleBack={this.handleBack}
                lng={this.props.language}
                branding={this.props.branding}
            />
        );
    }
}

const mapStateToProps = (state: Object) => {
    return {
        modal: state.modal,
        clientID: state.paywall.clientID,
        language: state.auth.language,
        branding: state.branding,
        assetID: state.modal.assetID,
        fees: state.modal.assetID
            ? state.assets[state.modal.assetID].access_fees
            : [],
    };
};

export default connect(
    mapStateToProps,
    {
        fetchAccessFees,
        selectFee,
        setForm,
        freemium,
        closeModal,
    }
)(PriceOptions);



// WEBPACK FOOTER //
// ./src/containers/Forms/PriceOptions.js